/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface OtherCostRowData
 */
export interface OtherCostRowData {
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    sourceName?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    domainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    centreId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    centreName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    since?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    until?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    overlapSince?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    overlapUntil?: string;
    /**
     * 
     * @type {number}
     * @memberof OtherCostRowData
     */
    sourceDays?: number;
    /**
     * 
     * @type {number}
     * @memberof OtherCostRowData
     */
    allocatedDays?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof OtherCostRowData
     */
    originalSpend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof OtherCostRowData
     */
    allocatedSpend?: MoneyOutput;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    allocationRule?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherCostRowData
     */
    note?: string | null;
}

/**
 * Check if a given object implements the OtherCostRowData interface.
 */
export function instanceOfOtherCostRowData(value: object): value is OtherCostRowData {
    return true;
}

export function OtherCostRowDataFromJSON(json: any): OtherCostRowData {
    return OtherCostRowDataFromJSONTyped(json, false);
}

export function OtherCostRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherCostRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'type': json['type'] == null ? undefined : json['type'],
        'category': json['category'] === undefined ? undefined : json['category'] === null ? null : json['category'],
        'domainId': json['domainId'] === undefined ? undefined : json['domainId'] === null ? null : json['domainId'],
        'domainName': json['domainName'] === undefined ? undefined : json['domainName'] === null ? null : json['domainName'],
        'centreId': json['centreId'] === undefined ? undefined : json['centreId'] === null ? null : json['centreId'],
        'centreName': json['centreName'] === undefined ? undefined : json['centreName'] === null ? null : json['centreName'],
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'overlapSince': json['overlapSince'] == null ? undefined : json['overlapSince'],
        'overlapUntil': json['overlapUntil'] == null ? undefined : json['overlapUntil'],
        'sourceDays': json['sourceDays'] == null ? undefined : json['sourceDays'],
        'allocatedDays': json['allocatedDays'] == null ? undefined : json['allocatedDays'],
        'originalSpend': json['originalSpend'] == null ? undefined : MoneyOutputFromJSON(json['originalSpend']),
        'allocatedSpend': json['allocatedSpend'] == null ? undefined : MoneyOutputFromJSON(json['allocatedSpend']),
        'allocationRule': json['allocationRule'] == null ? undefined : json['allocationRule'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
    };
}

export function OtherCostRowDataToJSON(json: any): OtherCostRowData {
    return OtherCostRowDataToJSONTyped(json, false);
}

export function OtherCostRowDataToJSONTyped(value?: OtherCostRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sourceId': value['sourceId'],
        'sourceName': value['sourceName'],
        'type': value['type'],
        'category': value['category'],
        'domainId': value['domainId'],
        'domainName': value['domainName'],
        'centreId': value['centreId'],
        'centreName': value['centreName'],
        'since': value['since'],
        'until': value['until'],
        'overlapSince': value['overlapSince'],
        'overlapUntil': value['overlapUntil'],
        'sourceDays': value['sourceDays'],
        'allocatedDays': value['allocatedDays'],
        'originalSpend': MoneyOutputToJSON(value['originalSpend']),
        'allocatedSpend': MoneyOutputToJSON(value['allocatedSpend']),
        'allocationRule': value['allocationRule'],
        'note': value['note'],
    };
}

